module.exports = __webpack_public_path__ + "static/media/1350_popup_Exit_GiftShop_all.954424d4.png";